"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _APIs = require("../../constants/APIs");
var _SuggestBox = _interopRequireDefault(require("../materials/SuggestBox"));
var _CallAPI = require("../system/CallAPI");
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const StyledSuggestBox = (0, _styles.styled)(_SuggestBox.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginTop: theme.spacing(2)
  };
});

/**
 * 地域選択部品
 * @prop {string} [value] - 選択している地域コード
 * @prop {string} siteNo - 拠点番号
 * @prop {string} siteBuildingNm - 拠点名
 * @prop {string} kaishaCd - 会社コード
 * @prop {function} onAreaSiteChange - 変更された拠点のデータを受け取る関数
 * シグネチャ：function(obj)) => void
 * obj：選択された拠点情報オブジェクト
 * { siteNo:string, siteBuildingNm:string }
 */
class SelectArea extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "INIT_STATE", {
      kaishaCd: '',
      areaInfo: []
    });
    _defineProperty(this, "RESULT", {
      areaCd: '',
      areaNm: '',
      siteNo: '',
      siteBuildingNm: ''
    });
    _defineProperty(this, "handleOnChange", value => {
      const {
        siteNo,
        siteBuildingNm
      } = this.props;
      const selectArea = this.state.areaInfo.find(item => item.areaCd === value);
      if (selectArea === undefined) {
        this.RESULT.areaCd = null;
        this.RESULT.areaNm = '';
        this.RESULT.siteNo = null;
        this.RESULT.siteBuildingNm = '';
      } else {
        this.RESULT.areaCd = selectArea.areaCd;
        this.RESULT.areaNm = selectArea.areaNm;
        if (this.props.value !== value) {
          this.RESULT.siteNo = null;
          this.RESULT.siteBuildingNm = '';
        } else {
          this.RESULT.siteNo = siteNo;
          this.RESULT.siteBuildingNm = siteBuildingNm;
        }
      }
      this.props.onAreaSiteChange(this.RESULT);
    });
    this.state = _objectSpread({}, this.INIT_STATE);
    const {
      kaishaCd
    } = this.props;
    if (kaishaCd) {
      this.callApiSearch(kaishaCd);
    }
  }
  componentDidUpdate(prevProps) {
    const {
      kaishaCd
    } = this.props;
    if (kaishaCd && prevProps.kaishaCd !== kaishaCd) {
      this.callApiSearch(kaishaCd);
    }
  }
  callApiSearch(kaishaCd) {
    const sendData = {
      kaishaCd
    };
    this.props.callAPI(_APIs.AREA_SELECT_SEARCH, sendData).then(json => {
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        areaInfo: json.data ? json.data : []
      }));
    });
  }
  render() {
    const {
      value,
      error,
      helperText
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 8
      }
    }, /*#__PURE__*/_react.default.createElement(StyledSuggestBox, {
      value: value === null ? '' : value,
      onChange: this.handleOnChange,
      items: this.state.areaInfo.map(data => {
        return {
          displayName: data.areaNm,
          value: data.areaCd
        };
      }),
      error: !!error,
      helperText: helperText
    })));
  }
}
SelectArea.propTypes = {
  value: _propTypes.default.string,
  siteNo: _propTypes.default.string,
  siteBuildingNm: _propTypes.default.string,
  kaishaCd: _propTypes.default.string.isRequired,
  onAreaSiteChange: _propTypes.default.func.isRequired,
  error: _propTypes.default.bool,
  helperText: _propTypes.default.string
};
var _default = exports.default = (0, _CallAPI.withCallAPI)(SelectArea);